export default class InvoiceCustomer {
  constructor (id, orgNumber, companyName, email, distribution, marking, phone, postalAddress, postalCity, postalCode, reference, useCompanyAddress, mimerCustomerId, bulkInvoice, gln, vatNumber) {
    this.id = id
    this.orgNumber = orgNumber
    this.companyName = companyName
    this.email = email
    this.distribution = distribution
    this.marking = marking
    this.phone = phone
    this.postalAddress = postalAddress
    this.postalCity = postalCity
    this.postalCode = postalCode
    this.reference = reference
    this.useCompanyAddress = useCompanyAddress
    this.mimerCustomerId = mimerCustomerId
    this.bulkInvoice = bulkInvoice
    this.gln = gln
    this.vatNumber = vatNumber
  }

  static asInvoiceCustomers (json) {
    return json.map(invoiceCustomer => {
      return InvoiceCustomer.asInvoiceCustomer(invoiceCustomer)
    })
  }

  static asInvoiceCustomer (json) {
    return new InvoiceCustomer(
      json.id,
      json.org_number,
      json.company_name,
      json.email,
      json.distribution,
      json.marking,
      json.phone,
      json.postal_address,
      json.postal_city,
      json.postal_code,
      json.reference,
      json.use_company_address,
      json.mimer_id,
      json.bulk_invoice,
      json.gln || '',
      json.vat_number || ''
    )
  }

  get invoiceCustomerLink () {
    return { name: 'InvoiceCustomerCustomerListView', params: { invoiceCustomerId: this.id } }
  }

  updateCurrentInvoiceCustomer (invoiceCustomer) {
    if (this.id !== invoiceCustomer.id) {
      throw new Error('Objects missmatch')
    }
    this.orgNumber = invoiceCustomer.orgNumber
    this.companyName = invoiceCustomer.companyName
    this.email = invoiceCustomer.email
    this.distribution = invoiceCustomer.distribution
    this.marking = invoiceCustomer.marking
    this.phone = invoiceCustomer.phone
    this.postalAddress = invoiceCustomer.postalAddress
    this.postalCity = invoiceCustomer.postalCity
    this.postalCode = invoiceCustomer.postalCode
    this.reference = invoiceCustomer.reference
    this.useCompanyAddress = invoiceCustomer.useCompanyAddress
    this.mimerCustomerId = invoiceCustomer.mimerCustomerId
    this.bulkInvoice = invoiceCustomer.bulkInvoice
  }
}
